import { create } from 'zustand';
import { addDays, startOfDay } from 'date-fns';
import { getDateString, isValidDate } from '../../utils';

export const createCalendarSlice = (set, get) => ({
  calendar: {
    end_date: null,
    start_date: null,
  },
  setCalendar: (dateRange) => {
    if (dateRange?.some((d) => !isValidDate(d))) {
      console.error('Failed to setCalendar: Invalid Date', dateRange);
      return;
    }

    const [start_date, end_date] = dateRange;

    set({
      calendar: {
        end_date,
        start_date,
      },
    });
  },
});
